export const defaultSelectedDate = () => {
    var fecha = new Date();
    fecha.setDate(fecha.getDate()-30);
    return fecha;

};

export default {
    loading: {
        module: false
    },
    params: {
        year_month_from: defaultSelectedDate(),
        year_month_up: defaultSelectedDate(),
        account_from: null,
        account_up: null,
        description_account_from: null,
        description_account_up: null,
        view_delete_from: null,
        view_delete_up: null,
        filter_text: "",
        filter_tag: "",
        contact_id:null,
    },
    params_contacts:{
        paginate: false,
        page: 1,
        perPage: 50,
        query: '',
        filter: '',
        sortBy: 'id',
        sort: 'ASC',
        only_active:true,
        query:null,
    },
    contacts:[],
    params_accounts_from: {
        notAux: false,
        onlyAux: false,
        paginate: true,
        page: 1,
        perPage: 30,
        filter: "",
        sortBy: "code",
        sort: "ASC"
    },
    params_accounts_up: {
        notAux: false,
        onlyAux: false,
        paginate: true,
        page: 1,
        perPage: 30,
        filter: "",
        sortBy: "code",
        sort: "ASC"
    },
    accounts_from: [],
    accounts_up: [],
    auxiliary_book: [],
    trial_balance: [],
    ag_grid: {
        selectedTheme: 'ag-theme-balham'
    },
    iconAcordion: "ti-angle-down",
    balance_account_contact: [],
    balance_account_contact_document: [],
};




// WEBPACK FOOTER //
// ./src/modules/trial-balance-contact/state.js